export default {
  methods: {
    translateParameterNameByTag(tags) {
      if (tags.includes('effective work time')) {
        return t`v2.fm2.parameter.work`;
      }
      if (tags.includes('device active')) {
        return t`parameter.active`;
      }

      if (tags.includes('efficiency')) {
        return t`v2.fm2.parameter.efficiency`;
      }

      return tags[0];
    },
  },
};
